import React, { useContext, useEffect, useState } from "react";
import { ReportsFragmentContext } from "../../../../ReportFragment.jsx";
import { Button } from "react-bootstrap";

const CourseStudentAnalytics = () => {

    //@ts-ignore
    const { viewHandler, setViewHandler, companies, courseStudentAnalyticsFormData, setCourseStudentAnalyticsFormData } = useContext(ReportsFragmentContext);
    const token = localStorage.getItem("token") || "";
    const [courseStudentAnalyticsData, setCourseStudentAnalyticsData] = useState<string[]>([]);
    const [firstRender, setFirtRender] = useState<boolean>(true);
    const [courseStudentAnalyticsTableHeaders, setCourseStudentAnalyticsTableHeaders] = useState<string[]>([]);

    const fetchAnalysis = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions: any = {
            method: "POST",
            headers: { ...myHeaders, "Content-Type": "application/json" },
            body: JSON.stringify(courseStudentAnalyticsFormData),
            redirect: "follow"
        };

        fetch(`https://beiguru.co.in/admin/course-student-analytics`, requestOptions)
            .then(async (response: any) => {
                if (response.status != 200) { localStorage.clear(); window.location.reload(); }
                else { const data = await response.json(); setCourseStudentAnalyticsData(data); }
            })
            .catch((error) => console.error(error));
    }

    const downloadCSV = () => {
        if (!courseStudentAnalyticsData || courseStudentAnalyticsData.length === 0) { console.error("No data available to download"); return; }
        const headers = Object.keys(courseStudentAnalyticsData[0]);
        const rows = courseStudentAnalyticsData.map(row => headers.map(fieldName => `"${row[fieldName] !== null && row[fieldName] !== undefined ? row[fieldName] : ''}"`).join(","));
        const csvContent = [headers.join(","), ...rows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "course_student_analytics.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchAnalysis();
    }, [])

    useEffect(() => {
        if (courseStudentAnalyticsData.length > 0 && firstRender) {
            let tableHeaders = Object.keys(courseStudentAnalyticsData?.[0])
            setCourseStudentAnalyticsTableHeaders(tableHeaders)
            setFirtRender(false);
        }
    }, [courseStudentAnalyticsData])

    return (
        <React.Fragment>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', paddingBottom: '1rem' }}>
                <Button variant='outline-primary' style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px' }} onClick={() => downloadCSV()}>
                    Download CSV
                </Button>
                <Button variant='outline-primary' style={{ fontWeight: '600', borderRadius: '5px', marginLeft: '10px' }} onClick={() => setViewHandler(prevState => ({ ...prevState, subView: '' }))}>
                    Back
                </Button>
            </div>
            {courseStudentAnalyticsTableHeaders.length > 0 ? (
                <table style={{ flex: 1 }} className="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                            {courseStudentAnalyticsTableHeaders.map((header, index) => (
                                <th key={index}>{header.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {courseStudentAnalyticsData.map((data) => (
                            <tr key={data}>
                                {courseStudentAnalyticsTableHeaders.map((header, index) => (
                                    <td key={index}>{data[header]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) :
                (
                    null
                )
            }
        </React.Fragment>
    );
};

export default CourseStudentAnalytics;